function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime/helpers/assertThisInitialized.js
 ** module id = 108
 ** module chunks = 0
 **/